var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.764,
    height: 24,
    viewBox: "0 0 21.764 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M23.091,6.73a98.107,98.107,0,0,0-17.637-.2l-2.277.2a.824.824,0,0,1-.927-.68A.772.772,0,0,1,3,5.23l2.277-.2a101.057,101.057,0,0,1,17.983.2.777.777,0,0,1,.748.82.8.8,0,0,1-.826.68Z",
    transform: "translate(-2.246 -0.805)",
    fill: "#9e3323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M8.371,5.71a.753.753,0,0,1-.61-.86l.22-1.31c.16-.96.38-2.29,2.71-2.29h2.62c2.34,0,2.56,1.38,2.71,2.3l.22,1.3a.746.746,0,1,1-1.47.25l-.22-1.3c-.14-.87-.17-1.04-1.23-1.04H10.7c-1.06,0-1.08.14-1.23,1.03l-.23,1.3a.75.75,0,0,1-.74.63A.615.615,0,0,1,8.371,5.71Z",
    transform: "translate(-1.111 -1.25)",
    fill: "#9e3323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M9.445,22.75c-4.01,0-4.171-1.93-4.3-3.49L4.4,9.19a.8.8,0,0,1,.8-.8.838.838,0,0,1,.919.7l.747,10.07c.126,1.52.172,2.09,2.574,2.09h7.377c2.413,0,2.459-.57,2.574-2.09l.747-10.07a.846.846,0,0,1,.919-.7.8.8,0,0,1,.8.8L21.12,19.26c-.126,1.56-.287,3.49-4.3,3.49Z",
    transform: "translate(-2.246 1.25)",
    fill: "#9e3323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M10.33,17.25a.75.75,0,1,1,0-1.5h3.33a.75.75,0,1,1,0,1.5Z",
    transform: "translate(-1.113 0.562)",
    fill: "#9e3323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M9.5,13.25a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(-1.112 0.062)",
    fill: "#9e3323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9dbacdc649feb0f9cc50e14a17e67359.svg";
export { ForwardRef as ReactComponent };